import { useState } from "react";
import BoxControls from "../../Common/Box/BoxControls";
import IncomeGroupChooser from "../../Common/Box/Choosers/IncomeGroupChooser";
import Figure from "../../Common/Box/Figure";
import initialData from "../../../data/initialData.json";
import useAreaQuery from "../../../hooks/useAreaQuery";
import { getIncomeGroup, getTooltip } from "../../../utilities";

const number = 9;

const getSeriesColor = (name) => {
  switch (name) {
    case "2019":
      return "#f8aaaa";

    case "2025":
      return "#f37676";

    case "2030":
      return "#ed3333";

    default:
      return "black";
  }
};

const options = (data, props) => (theme) => {
  const series = data.map((series) => ({
    ...series,
    color: getSeriesColor(series.name),
  }));

  return {
    chart: {
      type: "column",
      width: 470,
      height: 300,
      backgroundColor: null,
    },
    xAxis: {
      categories: [
        "1: Maintain coverage",
        "2: Increase coverage",
        "3: Increase coverage and scale-up emerging drugs",
      ],
    },
    yAxis: {
      title: undefined,
      labels: {
        formatter: function () {
          return "$" + this.axis.defaultLabelFormatter.call(this);
        },
      },
    },
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: function () {
        return getTooltip("Cost", this.y, this.percentage, {
          prefix: "$",
        });
      },
      style: {
        fontSize: "0.875rem",
        color: theme.palette.tooltip.primary,
      },
    },
    exporting: {
      chartOptions: {
        title: undefined,
        subtitle: undefined,
      },
      enabled: false,
    },
    series,
  };
};

const MhF19 = (props) => {
  const [selectedIncomeGroupId, setSelectedIncomeGroupId] = useState(0);

  const { areaData: data } = useAreaQuery(
    `/mh/figures/19/${selectedIncomeGroupId}`,
    initialData["mh_f19"]
  );

  const handleIncomeGroupChange = (incomeGroupId) => {
    setSelectedIncomeGroupId(incomeGroupId);
  };

  return (
    <Figure
      id="MH_f19"
      number={number.toString()}
      fileStem={`mh_f${number}`}
      title="Change in Cost of Seven Priority Maternal Health Drugs Plus Two Emerging Drugs"
      subtitle="By Future Scenario, 2019-2030"
      chartOptions={options(data)}
      selection={getIncomeGroup(selectedIncomeGroupId)}
      controls={
        <BoxControls>
          <IncomeGroupChooser
            value={selectedIncomeGroupId}
            onChange={handleIncomeGroupChange}
          />
        </BoxControls>
      }
    />
  );
};

export default MhF19;
